export default __webpack_public_path__ + "static/media/Small.7c4e671f.png";